import React from "react";
import dayjs from "dayjs";


function MessageA7(props) {

  const messageContainerClassName = () => {
    return props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
  }

  const messageBoxStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA7Box;
  }

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA7Time;
  }

  const text = (props.entry && props.entry.text) || "";
  return (
    <div className={messageContainerClassName()}>
      <div className="s360-message-box-received" style={messageBoxStyle()} >
        <div><img width="100%" src ={props.entry.url} alt=""/>
          <span>{text}</span></div>
        
      </div>
      {  props.isLastEntry && props.sentTimestamp&& <div className="s360-message-time-received" style={messageTimeStyle()}>{dayjs.unix(Math.trunc(props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
    </div>
  );
}

export default MessageA7;
